import React from "react";
import { Heading, Subheading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useDocument } from "../../contexts/DocumentContext";
import CreateDocumentButton from "../../components/CreateDocumentButton/CreateDocumentButton";
import EmptyStateView from "../../components/EmptyStateView";
import DocumentListItem from "./DocumentListItem";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import TasksComponent from "../../components/TaskComponent/TasksComponent";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import DocumentRecommendationsCard from "./components/DocumentRecommendationsCard";

const DocumentListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { documents, loading, error } = useDocument();

  if (loading.list) {
    return <LoadingView title="Loading documents..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div>
      <div className="flex items-end justify-between gap-4 mb-6">
        <Heading className="text-2xl font-bold">Documents</Heading>
        <div className="flex space-x-4">
          <CreateDocumentButton />
        </div>
      </div>
      <TasksComponent taskType="document" />

      {documents.length === 0 && (
        <EmptyStateView
          title="No Documents"
          message="No documents found. Create some to get started."
        />
      )}
      {documents.length > 0 && (
        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader className="text-left">Name</TableHeader>
              <TableHeader className="text-right">Last Updated</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.map((document) => (
              <DocumentListItem key={document._id} document={document} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default DocumentListPage;
